import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import OfferingsSplit from './components/OfferingsSplit';
import About from './pages/About';
import Footer from './components/Footer';
import MobileCtaBar from './components/MobileCtaBar';
import AnalyticsListener from './analytics/AnalyticsListener';
import FAQ from './components/FAQ';
import ClientGallery from './pages/ClientGallery';
import RetroBooth from './pages/RetroBooth';
import ContactPage from './pages/ContactPage';
import Testimonials from './components/Testimonials';
import OurWork from './components/OurWork';
import { useSeo } from './seo/useSeo';
import SEO_PAGES from './seo/pages.json';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';


function HomePage() {
  const location = useLocation();

  useSeo({ ...SEO_PAGES['/'], canonicalPath: '/' });

  useEffect(() => {
    // Handle scroll to section if there's a hash in the URL
    if (location.hash) {
      const targetSection = document.querySelector(location.hash);
      if (targetSection) {
        setTimeout(() => {
          const navbar = document.querySelector('.navbar');
          const navbarHeight = navbar ? navbar.offsetHeight : 80;
          const headerOffset = navbarHeight + 20;
          const elementTop = targetSection.offsetTop;
          const offsetPosition = elementTop - headerOffset;

          window.scrollTo({
            top: Math.max(0, offsetPosition),
            behavior: 'smooth'
          });
        }, 200);
      }
    }

    // Smooth scrolling for navigation links
    const navLinks = document.querySelectorAll('a[href^="#"]');

    const handleNavClick = (e) => {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href');
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        const navbar = document.querySelector('.navbar');
        const navbarHeight = navbar ? navbar.offsetHeight : 80;
        const headerOffset = navbarHeight + 20;
        const elementTop = targetSection.offsetTop;
        const offsetPosition = elementTop - headerOffset;

        window.scrollTo({
          top: Math.max(0, offsetPosition),
          behavior: 'smooth'
        });
      }
    };

    navLinks.forEach(link => link.addEventListener('click', handleNavClick));

    // Scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    const fadeElements = document.querySelectorAll('.fade-in');
    fadeElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });

    // Navbar scroll effect
    const navbar = document.querySelector('.navbar');
    const handleScroll = () => {
      if (window.scrollY > 50) {
        navbar.style.background = 'rgba(248, 237, 220, 0.98)';
        navbar.style.borderBottomColor = 'rgba(62, 60, 48, 0.1)';
      } else {
        navbar.style.background = 'rgba(248, 237, 220, 0.95)';
        navbar.style.borderBottomColor = 'rgba(62, 60, 48, 0.05)';
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
      navLinks.forEach(link => link.removeEventListener('click', handleNavClick)); // ← cleanup added
    };
  }, [location.hash]);

  return (
    <>
      <Hero />
      <OfferingsSplit />
      <Testimonials />
      <OurWork />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/gallery" element={<ClientGallery />} />
          <Route path="/retro-booth" element={<RetroBooth />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <AnalyticsListener />
        <Footer />
        <MobileCtaBar />
      </div>
    </Router>
  );
}

export default App;
